<div class="ranking-filters-container">
  <!-- Header with rank text and filters -->
  <div class="ranking-header">
    <div class="rank-text">{{ getRankDisplayText() }}</div>
    <form [formGroup]="form" class="form-class">
    <!-- <div class="form-container-left" fxLayout="row" fxLayoutGap="15px">
    </div> -->
    <div class="form-container-right" fxLayout="row" fxLayoutGap="16px">
      <mtn-comparison-type-field [form]="form"></mtn-comparison-type-field>
      <mtn-region-field [form]="form" [isMarketAreaAvailable]="!!marketArea?.getFeature()"></mtn-region-field>
      <mtn-drive-time-minutes-field [form]="form"
                                    *ngIf="form.get('region').value === RegionType.DRIVE_TIME"></mtn-drive-time-minutes-field>
      <mtn-ring-miles-field [form]="form"
                            *ngIf="form.get('region').value === RegionType.RING"></mtn-ring-miles-field>
    </div>
  </form>
     
  </div>
</div>
  
